import { render, staticRenderFns } from "./CustomGroup.vue?vue&type=template&id=0f794680&scoped=true&"
import script from "./CustomGroup.vue?vue&type=script&lang=js&"
export * from "./CustomGroup.vue?vue&type=script&lang=js&"
import style0 from "./CustomGroup.vue?vue&type=style&index=0&id=0f794680&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f794680",
  null
  
)

export default component.exports